<div class="container">
  <div class="admin-page-header">
    <h2 class="title admin-page-title">Configuracion</h2>
    <div class="dialog-actions-wrap">
      <span class="summary-chip">Total: {{ configs.length }}</span>
      <button mat-raised-button color="primary" class="btn-round" (click)="setOpen()">
        <mat-icon>add</mat-icon>
        Nueva configuracion
      </button>
    </div>
  </div>

  <mat-card class="table-card">
    <app-data-table
      [dataSource]="configs"
      [displayedColumns]="displayedColumns"
      [emptyMessage]="'No hay configuraciones disponibles.'"
      [rowClickable]="true"
      (rowClick)="setOpen($event.row)">
      <ng-container matColumnDef="key">
        <th mat-header-cell *matHeaderCellDef>Key</th>
        <td mat-cell *matCellDef="let config">{{ config.key }}</td>
      </ng-container>

      <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef>Value</th>
        <td mat-cell *matCellDef="let config">{{ config.value | slice:0:20 }}</td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Description</th>
        <td mat-cell *matCellDef="let config">{{ config.description }}</td>
      </ng-container>
    </app-data-table>
  </mat-card>
</div>
